export default __webpack_public_path__ + "static/media/partner-11-magic-eden.14c790a3.png";